import { Stack, Typography } from '@mui/material';
import { Show, UserAvatar } from '@side/pantry';
import { EmptyTableCell } from '@/components/EmptyTableCell';

export const UserCell = ({
  displayName,
  photoUrl,
}: {
  displayName?: string;
  photoUrl?: string;
}) => {
  return (
    <Stack
      direction="row"
      sx={{ gap: 1, alignItems: 'center', height: '100%' }}
    >
      <UserAvatar
        name={displayName ?? ''}
        avatarUrl={photoUrl ?? undefined}
        sx={{
          width: 30,
          height: 30,
          '&.MuiAvatar-root': { fontSize: '15px' },
        }}
      />
      <Show when={displayName} fallback={<EmptyTableCell />}>
        <Typography variant="subtitle2">{displayName}</Typography>
      </Show>
    </Stack>
  );
};

export const TeamCell = ({ teamName }: { teamName?: string }) => {
  return (
    <Stack
      direction="row"
      sx={{ gap: 1, alignItems: 'center', height: '100%' }}
    >
      <Show when={teamName} fallback={<EmptyTableCell />}>
        <Typography variant="subtitle2">{teamName}</Typography>
      </Show>
    </Stack>
  );
};
